import React from "react";
import './gr-employee.scss';
import PrButtonComponent from "../../../components/primitives/pr-button";


export default class GrEmployeeComponent extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            activeItem: false
        }
        this.component = React.createRef();
        this.activeFirst = this.props.firstActive;
    }

    componentDidMount(){
        const item = this.component.current.querySelector('.content');

        item.style.setProperty('--employee-height', `${item.getBoundingClientRect().height}px`);
    }

    listState(event){
        this.activeFirst = '';
        if(event.target.parentElement.classList.contains('firstActive')){
            this.activeFirst = '';
            this.setState({activeItem: false});
        }else{
            this.setState({activeItem: !this.state.activeItem});
        }
    }

    render(){
        return (
            <div className="employee y-sync" ref={this.component}>
                <div className="img-wrap">
                    <div className={`wrap_illustration set-${this.props.index}`}>
                        {Object.entries(this.props.data.img).map((data, index) =>
                            <div className={data[0]} key={index} >
                                <img src={data[1]} alt="#" />
                            </div>
                        )}
                    </div>
                    <div className="wrap_photo">
                        <img src={this.props.data.photo} alt="#" />
                    </div>
                </div>
                <div className={`wrap ${this.activeFirst} ${this.state.activeItem ? 'visible' : ''}`}>
                    <p className="title extra-title--h3" onClick={(event) => this.listState(event)}>{this.props.data.name}</p>
                    <div className="content">
                        <div className="img-wrap mobile-block">
                            <img src={this.props.data.photo} alt="#" />
                        </div>
                        <div className="block">
                            <p className="desc extra-title--h6">{this.props.data.content.length > 110 ? `${this.props.data.content.substring(0, 110)}...` : this.props.data.content}</p>
                            <PrButtonComponent type="secondary smallfont" content="Learn more" link={this.props.data.link}></PrButtonComponent>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
